var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const options = [
    { id: "task", name: "task" },
    { id: "survey", name: "survey" },
    { id: "meeting", name: "meeting" },
    { id: "note", name: "note" },
];
export default class EngagementTypeService {
    static searchAll(search) {
        return __awaiter(this, void 0, void 0, function* () {
            return options.filter((engagementType) => engagementType.name.includes(search));
        });
    }
    static findByIds(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'number'.
            return options.filter((engagementType) => ids.includes(engagementType.id));
        });
    }
}
